module.exports = __webpack_public_path__ + "img/backgroundFeature-2.2b42cc29.svg";